import ApiManager from '../../api/crud-manager';
import jsonToView from '../../api/json-to-view';

/**
 * Class real time product price module
 * @class
 * @author Max Swinkels <max.swinkels@pangaea.nl>
 *
 */

class RealTimePrice {
  constructor(options = {}) {
    this.config = {
      moduleList: () => document.querySelectorAll('[data-module="RealTimePrice"]'),
      apiManager: new ApiManager(),
      ...options
    };
  }

  // fetch product price based on product id
  async getPrice(productId, quantity = 1, currency = 'EUR') {
    const { apiManager } = this.config;

    const url = `/api/v2/catalog/product/${productId}/prices?quantity=${quantity}&currency=${currency}`;

    return apiManager.get(url).then(data => data);
  }

  filterUniqueLowestQuantity(items) {
    const priceMap = new Map();

    items.forEach(item => {
      const priceKey = `${item.price.originalPrice}-${item.price.currentPrice}-${
        item.price.originalPriceInclVat
      }-${item.price.currentPriceInclVat}`;

      if (!priceMap.has(priceKey) || item.price.quantity < priceMap.get(priceKey).price.quantity) {
        priceMap.set(priceKey, item);
      }
    });

    return Array.from(priceMap.values());
  }

  init() {
    const { moduleList } = this.config;

    moduleList().forEach(async _module => {
      const module = _module;

      const {
        productId,
        hasChildren,
        pricesExTax,
        resourceErrorMessage,
        initialized,
        staffel,
        overview
      } = module.dataset;

      if (!productId && initialized != null && initialized) return;

      module.dataset.initialized = true; // skip initialized module items
      module.classList.add('is-loading');
      const templateView = 'RealTimePrice';

      const staffels = staffel.split('#');
      if ((overview && overview === 'true') || staffels.length <= 1) {
        this.getPrice(productId)
          .then(response => {
            // eslint-disable-next-line no-underscore-dangle
            const { prices } = response._embedded;

            const viewData = {
              price: prices.length ? prices[0] : null,
              hasChildren,
              pricesExTax
            };

            // create view based on template file
            jsonToView(viewData, templateView)
              .then(html => {
                module.classList.remove('is-loading');
                module.innerHTML = html;
              })
              .catch(error => {
                module.classList.remove('is-loading');
                module.innerHTML = resourceErrorMessage || 'Price not available';
                throw new Error(error);
              });
          })
          .catch(error => {
            module.classList.remove('is-loading');
            module.innerHTML = resourceErrorMessage || 'Price not available';
            throw new Error(error);
          });
      } else {
        const priceCalls = staffels.map(async quantity => {
          const price = await this.getPrice(productId, quantity);
          if (
            !price ||
            !price._embedded ||
            !price._embedded.prices ||
            price._embedded.prices.length <= 0
          ) {
            return null;
          }

          const data = price._embedded.prices[0];
          return {
            price: data,
            hasChildren,
            pricesExTax
          };
        });

        const response = await Promise.all(priceCalls);
        const prices = this.filterUniqueLowestQuantity(response);

        if (prices.length === 1) {
          jsonToView(prices[0], templateView)
            .then(html => {
              module.classList.remove('is-loading');
              module.innerHTML = html;
            })
            .catch(error => {
              module.classList.remove('is-loading');
              module.innerHTML = resourceErrorMessage || 'Price not available';
              throw new Error(error);
            });
        } else {
          jsonToView(prices, 'RealTimePriceStaffel')
            .then(html => {
              module.classList.remove('is-loading');
              module.innerHTML = html;
            })
            .catch(error => {
              module.classList.remove('is-loading');
              module.innerHTML = resourceErrorMessage || 'Price not available';
              throw new Error(error);
            });
        }
      }
    });
  }
}

export default RealTimePrice;
